<template>
  <section class="card-slider">
    <h2 class="card-slider__title">
      {{ title }}
    </h2>

    <FlickitySlider white>
      <ImageCard
        v-for="(card, i) of caseStudies"
        class="card-slider__card"
        :key="card.title"
        v-bind="card"
        :cardType="generalCardLabel"
        clickable
        @onClick="$emit('onCardClick', i)"
      />
    </FlickitySlider>
  </section>
</template>

<script setup>
import ImageCard from "../atoms/ImageCard.vue";
import FlickitySlider from "../atoms/FlickitySlider.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineProps({
  cardType: String,
  title: String,
  generalCardLabel: String,
  cards: {
    type: Array,
    default: () => [],
  },
  white: Boolean,
});

const { tm } = useI18n();

const caseStudies = computed(() => {
  const caseContent = tm("case-study");

  return Object.keys(caseContent).map((caseStudy) => ({
    title: caseContent[caseStudy][0].content.title,
    imagePath: `case-${caseStudy}-card`,
    routeObj: { name: "page", params: { page: "home" }, query: { caseStudy } },
  }));
});
</script>

<style lang="scss" scoped>
.card-slider {
  background-color: var(--background-weaker);
  padding: 7vh calc(var(--page-padding-h) + var(--page-padding-h-offset));
  position: relative;
  // width: var(--vw-no-scrollbar, 100vw);
  overflow: hidden;

  .case-study & {
    background-color: var(--background-weaker-inverted);
    color: var(--color-white);
    border-top: 1px solid var(--text-disabled);
  }

  &__title {
    @include header-h-1;

    margin-bottom: 1.75rem;

    .mobile & {
      margin-bottom: 1.5rem;
      @include header-h-3;
    }
  }

  &__card {
    margin: 0 0.5rem;
    justify-content: flex-end;
  }
}
</style>
